import React, { lazy } from 'react';
import GenerateOne from './GenerateOne';
import "./Index.css"
const GenerateTwo = lazy(()=> import("./GenerateTwo"))
const GenerateThree = lazy(()=> import("./GenerateThree"))


const Home = () => {

    return (
        <div className='section-container'>
            <GenerateOne />
            <GenerateTwo />
            <GenerateThree />
           </div >
    )
}
export default Home